module.exports = __webpack_public_path__ + "img/hero-slider-2.6c50adf0.jpeg";